export const components = {
  emptyState: {
    primaryTitle: 'Упс!',
    primaryText: 'Здесь пока ничего нет…',
    secondaryTitle: 'Нет результатов…',
    secondaryText: 'К сожалению, по выбранным фильтрам нет ни одного результата…'
  },
  filters: {
    all: 'Все',
    search: 'Поиск',
    priceRange: 'Диапазон цен {currency}',
    minValue: 'Минимальное значение {val}!',
    maxValue: 'Максимальное значение {val}!',
    reset: 'Сбросить',
    apply: 'Применить'
  },
  comments: {
    reply: 'Ответить',
    loadMore: 'Загрузить ещё',
    edited: 'Отредактировано',
    noComments: 'Нет комментариев',
    leaveFirstComment: 'Оставьте первый комментарий'
  },
  curtain: {
    close: 'Закрыть'
  },
  photoPreview: {
    close: 'Закрыть'
  },
  photoCropper: {
    back: 'Назад',
    save: 'Сохранить'
  },
  rightSidebar: {
    in: 'в'
  },
  pushPrompt: {
    title: '“{appName}” хочет отправлять вам Push-уведомления',
    description: 'Уведомления могут включать оповещения, звуки и метки.',
    later: 'Спросить позже',
    neverLater: 'Больше не спрашивать',
    allow: 'Разрешить'
  },
  inAppPush: {
    attachment: 'Вложение'
  },
  installPrompt: {
    android: {
      install: 'Установить',
      description: 'Для беспрепятственной работы вам не нужно использовать браузер. Просто установите приложение прямо здесь.',
      press: 'Нажмите',
      andSelect: 'и выберите',
      orSimply: 'или просто',
      description2: 'нажмите на кнопку ниже',
      notNow: 'Не сейчас'
    },
    ios: {
      justTap: 'Нажмите на',
      buttonInBrowser: 'кнопку «Ещё» в вашем браузере и выберите «Поделиться»',
      addToHomeScreen: 'Прокрутите вниз и нажмите «На экран Домой», затем нажмите «Добавить»',
      appWillBeInstalled: 'Приложение будет добавлено на ваш домашний экран'
    },
    installApp: 'Установить приложение',
    useWeb: 'Использовать браузер'
  },
  footer: {
    more: 'Меню'
  },
  menu: {
    installApp: 'Установить приложение',
    menu: 'Меню',
    close: 'Закрыть'
  },
  404: {
    whoops: 'Упс!',
    description:
      'Похоже, эта страница не существует, или у вас недостаточно прав для её просмотра. Чтобы узнать больше, свяжитесь с владельцем приложения.',
    ok: 'ОК'
  },
  relatedUsers: {
    seeall: 'Смотреть все'
  },
  networkingCurtain: {
    'newOneOnOne': 'Новое 1:1',
    'details': 'Детали',
    'coverMessage': 'Сопроводительный текст',
    'location': 'Место встречи',
    'duration': 'Продолжительность',
    '15min': '15 мин',
    '30min': '30 мин',
    '45min': '45 мин',
    '60min': '60 мин',
    'timeSlot': 'Дата, время',
    'sendInvitation': 'Отправить приглашение',
    'success': 'Успех',
    'invitationSent':
      'Вы успешно отправили приглашение на встречу 1:1. Хотите остаться на этой странице или перейти ко всем вашим запланированным встречам 1:1?',
    'seeAll': 'Посмотреть все 1:1 встречи',
    'stayHere': 'Остаться здесь'
  },
  networking: {
    level: {
      1: 'Пока не готов к нетворкингу. Никакой значимой активности.',
      2: 'Низкая активность или отсутствуют ключевые детали профиля.',
      3: 'Профиль заполнен c фото и пользователь онлайн, полностью готов к началу общения.',
      4: 'Набирает обороты – инициирована по крайней мере одна установка контакта за последние 6 часов.',
      5: 'Мастер нетворкинга – активно отвечает на запросы и общается с другими в течение последних 6 часов.'
    }
  },
  time: {
    days: 'д',
    hours: 'ч',
    minutes: 'м',
    seconds: 'с',
    startsIn: 'через',
    Today: 'Сегодня',
    today: 'сегодня',
    Tomorrow: 'Завтра',
    tomorrow: 'завтра',
    Yesterday: 'Вчера',
    yesterday: 'вчера',
    startingNow: 'начинается сейчас'
  },
  daysMonths: {
    months: "['Январь','Февраль','Март','Апрель','Май','Июнь','Июль','Август','Сентябрь','Октябрь','Ноябрь','Декабрь']",
    monthsShort: "['Янв', 'Фев', 'Мар', 'Апр', 'Май', 'Июн', 'Июл', 'Авг', 'Сен', 'Окт', 'Ноя', 'Дек']",
    weekdays: "['Воскресенье', 'Понедельник', 'Вторник', 'Среда', 'Четверг', 'Пятница', 'Суббота']",
    weekdaysShort: "['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб']",
    weekdaysMin: "['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб']"
  },
  badges: {
    legend: 'Legendary Networker',
    push: 'Online and Trusted',
    leader: 'Leaderboard Champ',
    meetmaster: '1:1 Meeting Master',
    connector: '3-Time Connector',
    legend_description: 'Достиг уровня “Legend” хотя бы один раз, активно общаясь и создавая значимые связи.',
    push_description: 'Разрешил push-уведомления, чтобы оставаться на связи и не упускать возможности.',
    leader_description: 'Попал в топ 10% в таблице лидеров хотя бы один раз.',
    meetmaster_description: 'Инициировал или ответил как минимум на один запрос на 1:1 встречу в приложении.',
    connector_description: 'Установил хотя бы три коннекта используя нетворкинг в приложении.'
  }
}
